<template>
  <div id="mainMenu" class="container v-menu-container tooltip-wrapper">
    <ul
      id="v-menu"
      class="sky-mega-menu sky-mega-menu-anim-scale sky-mega-menu-response-to-icons"
    >
      <venues :active="activeMenu === 'venues'"></venues>
      <events :active="activeMenu === 'events'"></events>
      <inventory :active="activeMenu === 'inventory'"></inventory>
      <customers :active="activeMenu === 'customers'"></customers>
      <settings :active="activeMenu === 'settings'"></settings>

      <!-- BEGIN Actions -->
      <li
        class="right quick-action"
        data-toggle="tooltip"
        data-placement="left"
        title="Aktionen"
      >
        <a href="#" class="quick-action"
          ><i class="fa fa-link quick-action-fa"></i>
          <span
            class="badge badge-new-todos-actions"
            data-toggle="tooltip"
            data-placement="right"
            data-html="true"
            title="Todos badge text"
            >1</span
          >
        </a>
        <div class="grid-container3">
          <ul>
            <li>
              <a href="/staff/todos/my/"
                ><i class="fa fa-fw fa-sticky-note-o"></i> Meine TODOs
                <span
                  class="badge badge-new-todos"
                  data-toggle="tooltip"
                  data-placement="right"
                  data-html="true"
                  title="todo text"
                  >1</span
                >
              </a>
            </li>
            <li>
              <a href="/customers/new/"
                ><i class="fa fa-fw fa-user-plus"></i> Neuer Kunde</a
              >
            </li>
            <li>
              <a href="/customers/goodsandservices/i/"
                ><i class="fa fa-fw fa-file-text-o"></i> Rechnung erstellen</a
              >
            </li>
            <li>
              <a href="/venues/scheduler/"
                ><i class="fa fa-fw fa-calendar"></i> Kalender</a
              >
            </li>
            <li>
              <router-link :to="{ name: 'VenueTimetable' }"
                ><i class="fa fa-fw fa-clock-o"></i> Freie Zeiten</router-link
              >
            </li>
            <li>
              <a href="/reports/daily-accounting/"
                ><i class="fa fa-fw fa-calculator"></i> Tagesabrechnung</a
              >
            </li>
            <li>
              <a href="#" target="_blank"
                ><i class="fa fa-fw fa-server"></i> Buchungswidget</a
              >
            </li>

            <li>
              <a href="https://handbuch.venuzle.at" target="_blank"
                ><i class="fa fa-fw fa-lightbulb-o"></i> Online-Handbuch</a
              >
            </li>
            <li>
              <a href="/internals/"
                ><i class="fa fa-fw fa-medkit"></i> Venuzle Internals</a
              >
            </li>
            <li>
              <a href="/login/account/"
                ><i class="fa fa-fw fa-cog"></i> Mein Account</a
              >
            </li>
            <li>
              <a @click="logOut" class="pointer"
                ><i class="fa fa-fw fa-sign-out"></i> Abmelden</a
              >
            </li>
          </ul>
        </div>
      </li>
      <!-- END Actions -->

      <!-- Partners -->
      <partners></partners>
    </ul>
  </div>
</template>

<script>
import Events from "@/components/Layout/ManagerMenu/Events.vue";
import Inventory from "@/components/Layout/ManagerMenu/Inventory.vue";
import Customers from "@/components/Layout/ManagerMenu/Customers.vue";
import Settings from "@/components/Layout/ManagerMenu/Settings.vue";
import Venues from "@/components/Layout/ManagerMenu/Venues.vue";
import Partners from "@/components/Layout/ManagerMenu/Partners.vue";

export default {
  data() {
    return {
      activeMenu: null,
      venueRoutes: [
        "BookingVenues",
        "NewBookingVenue",
        "BookingVenueDetails",
        "VenueCalendar"
      ],
      eventRoutes: [
        "BookingEvents",
        "NewBookingEvent",
        "BookingEventDetails",
        "UserEvents"
      ],
      inventoryRoutes: [
        "BookingInventoryProduct",
        "NewBookingInventoryProduct",
        "BookingInventoryProductDetails"
      ],
      customerRoutes: [
        "CustomersOverview",
        "NewCustomer",
        "CustomerData",
        "CustomerContacts",
        "NewCustomerContact",
        "CustomerContactDetails",
        "CustomerParticipants",
        "NewCustomerParticipant",
        "CustomerParticipantDetails"
      ]
    };
  },

  components: {
    Events,
    Inventory,
    Customers,
    Settings,
    Venues,
    Partners
  },

  mounted() {
    this.setActiveMenuByRoute(this.$route.path);
    this.setActiveMenuByRouteName(this.$route.name);
  },

  methods: {
    logOut() {
      localStorage.removeItem("partnerId");
      localStorage.removeItem("partnerCode");
      window.location.replace("/login");
    },

    setActiveMenuByRouteName(name) {
      if (this.venueRoutes.indexOf(name) > -1) {
        this.activeMenu = "venues";
      }
      if (this.eventRoutes.indexOf(name) > -1) {
        this.activeMenu = "events";
      }
      if (this.customerRoutes.indexOf(name) > -1) {
        this.activeMenu = "customers";
      }
      if (this.inventoryRoutes.indexOf(name) > -1) {
        this.activeMenu = "inventory";
      }
    },

    setActiveMenuByRoute(route) {
      if (route.indexOf("/settings") > -1) {
        this.activeMenu = "settings";
      }
    }
  },

  watch: {
    "$route.path": function(newState) {
      this.setActiveMenuByRoute(newState);
    },
    "$route.name": function(newState) {
      this.setActiveMenuByRouteName(newState);
    }
  }
};
</script>
